module.exports = __webpack_public_path__ + "static/media/sausage-truck.40375ede.svg";